<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height"
    viewBox="0 0 51.18 22.512">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_11567" data-name="Rectangle 11567" :width="width" :height="height" :fill="themeColor" />
      </clipPath>
    </defs>
    <g id="Electric" transform="translate(0 0)">
      <g id="Group_27789" data-name="Group 27789" transform="translate(0 0)" clip-path="url(#clip-path)">
        <path id="Path_86998" data-name="Path 86998"
          d="M39.308,27.635a1.362,1.362,0,0,1-1.334-1.641l.96-4.608H37.278a1.363,1.363,0,0,1-1.137-2.114l5.841-8.846a1.363,1.363,0,0,1,2.488.936l-.661,4.815h1.768a1.363,1.363,0,0,1,1.107,2.157l-6.27,8.733a1.366,1.366,0,0,1-1.107.568m-1.276-8.016h3.076L40.1,24.48l4.692-6.535H41.782l.693-5.056Z"
          transform="translate(-18.75 -5.123)" :fill="themeColor" />
        <path id="Path_86999" data-name="Path 86999"
          d="M83.09,34.763a4.589,4.589,0,1,0-4.588-4.59h0a4.594,4.594,0,0,0,4.588,4.589m0-7.449a2.86,2.86,0,1,1-2.859,2.861h0a2.864,2.864,0,0,1,2.859-2.86"
          transform="translate(-40.983 -13.357)" :fill="themeColor" />
        <path id="Path_87000" data-name="Path 87000"
          d="M17.936,34.763a4.589,4.589,0,1,0-4.589-4.589,4.589,4.589,0,0,0,4.589,4.589m0-7.449a2.86,2.86,0,1,1-2.861,2.86,2.861,2.861,0,0,1,2.861-2.86"
          transform="translate(-6.968 -13.357)" :fill="themeColor" />
        <path id="Path_87001" data-name="Path 87001"
          d="M2.3,17.815H4.5a.864.864,0,0,0,0-1.728H2.465c-.356-.54-.716-2.767-.737-5.533l.765-1.177a.855.855,0,0,0,.123-.3C3.3,5.661,4.532,2.313,5.208,2.051,6.5,1.881,25.7,1.309,29.4,2.307c1.26.34,2.837,1.831,4.228,3.147a13.157,13.157,0,0,0,3.057,2.439,18.9,18.9,0,0,0,5.131.624c2.15.108,5.094.255,5.813.76.442.424,1.24,3.255,1.751,5.8l-1.246,1.274a.864.864,0,0,0,1.235,1.208l1.563-1.6a.864.864,0,0,0,.231-.766c-.455-2.389-1.388-6.518-2.541-7.329-1.049-.737-3.342-.9-6.72-1.072a21,21,0,0,1-4.522-.48A13.213,13.213,0,0,1,34.817,4.2c-1.54-1.455-3.284-3.1-4.965-3.558C25.725-.473,6.3.167,4.957.341c-2.076.278-3.389,5.2-4,8.232L.14,9.827A.865.865,0,0,0,0,10.3c0,7.515,1.729,7.515,2.3,7.515"
          transform="translate(0 0)" :fill="themeColor" />
        <path id="Path_87002" data-name="Path 87002"
          d="M58.8,35.387h7.021a.864.864,0,0,0,0-1.728H58.8a.864.864,0,1,0,0,1.728Z"
          transform="translate(-30.246 -17.572)" :fill="themeColor" />
        <path id="Path_87003" data-name="Path 87003"
          d="M4.938,2.608a.672.672,0,0,0,.076,0L7.47,2.393A.864.864,0,0,0,7.32.672L4.864.887a.864.864,0,0,0,.074,1.724"
          transform="translate(-2.131 -0.35)" :fill="themeColor" />
      </g>
    </g>
  </svg>

</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
